<template>
  <b-tab title="Medição de Espessura" :active="ativo" class="m-0 p-0">
    <div id="screen-form" class="pl-2 pr-2 mt-2">
      <div id="MedicaoEspessura">
        <b-container fluid>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::: PARTE SUPERIOR DO RELATORIO ::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row>
            <b-col cols="3">
              <b-img :src="require('/static/images/netech.png')" fluid alt="Responsive image" width="230" />
            </b-col>

            <b-col cols="6" class="pt-1">
              <h4 class="exo-2 center-text p-4">RELATÓRIO DE ENSAIO POR MEDIÇÃO DE ESPESSURA</h4>
            </b-col>

            <b-col cols="3" class="pl-5">
              <b-row><p class="m-0 p-0">ID. Relatório</p></b-row>
              <b-row><b-form-input size="sm" v-model="me.numero" /></b-row>
              <b-row><p class="m-0 p-0">Data</p></b-row>
              <b-row>
                <b-form-datepicker
                  size="sm"
                  v-model="me.data"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                />
              </b-row>
            </b-col>
          </b-row>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::           LATERAL ESQUERDA          :::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row>
            <b-col cols="6" class="m-0 p-0 pr-1">
              <b-row class="m-0 p-0">
                <b-col cols="12" class="p-0">
                  <div class="separador-div">
                    <strong>INFORMAÇÕES SOBRE O EQUIPAMENTO</strong>
                  </div>
                </b-col>
                <b-col cols="12" class="text-left p-0">
                  <p class="m-0 p-0">Descrição / Description</p>
                </b-col>
                <b-col cols="12" class="p-0">
                  <b-form-input size="sm" v-model="equipamento.nome" />
                </b-col>
                <b-col cols="12" class="text-left p-0">
                  <p class="m-0 p-0">Identificação / Identification</p>
                </b-col>
                <b-col cols="12" class="p-0">
                  <b-form-input size="sm" v-model="identificacao" />
                </b-col>
                <b-col cols="12" class="text-left p-0">
                  <p class="m-0 p-0">Dimensões / Dimensions</p>
                </b-col>
                <b-col cols="12" class="p-0">
                  <b-form-input size="sm" v-model="equipamento.dimensoes" />
                </b-col>
                <b-col cols="6" class="text-left p-0">
                  <p class="m-0 p-0">Material / Material</p>
                </b-col>
                <b-col cols="6" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Peso / Weight</p>
                </b-col>
                <b-col cols="6" class="p-0">
                  <b-form-input size="sm" v-model="me.material" />
                </b-col>
                <b-col cols="6" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="equipamento.peso" />
                </b-col>
              </b-row>
            </b-col>
            <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
            <!-- :::::::::::::::::           LATERAL DIREITA           :::::::::::::::::: -->
            <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
            <b-col cols="6" class="m-0 p-0 pl-1">
              <b-row class="m-0 p-0">
                <b-col cols="12" class="p-0">
                  <div class="separador-div">
                    <strong>TÉCNICA DE MEDIÇÃO</strong>
                  </div>
                </b-col>
                <b-col cols="6" class="text-left p-0">
                  <p class="m-0 p-0">Descrição / Description</p>
                </b-col>
                <b-col cols="6" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Transdutor / Transducer</p>
                </b-col>
                <b-col cols="6" class="p-0">
                  <b-form-input size="sm" v-model="me.tecnica" />
                </b-col>
                <b-col cols="6" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="me.transdutor" />
                </b-col>
                <b-col cols="6" class="text-left p-0">
                  <p class="m-0 p-0">Superfície / Surface</p>
                </b-col>
                <b-col cols="6" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Temperatura / Temp.</p>
                </b-col>
                <b-col cols="6" class="p-0">
                  <b-form-input size="sm" v-model="me.superficie" />
                </b-col>
                <b-col cols="6" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="me.temperatura" />
                </b-col>
                <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
                <b-col cols="6" class="text-left p-0">
                  <p class="m-0 p-0">Descrição / Description</p>
                </b-col>
                <b-col cols="6" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Fabricante / Manufacturer</p>
                </b-col>
                <b-col cols="6" class="p-0">
                  <b-form-input size="sm" v-model="me.medidor.descricao" />
                </b-col>
                <b-col cols="6" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="me.medidor.fabricante" />
                </b-col>
                <b-col cols="4" class="text-left p-0">
                  <p class="m-0 p-0">Modelo / Model</p>
                </b-col>
                <b-col cols="4" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Nº Série / Series No.</p>
                </b-col>
                <b-col cols="4" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Certificado / Certificate</p>
                </b-col>
                <b-col cols="4" class="p-0">
                  <b-form-input size="sm" v-model="me.medidor.modelo" />
                </b-col>
                <b-col cols="4" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="me.medidor.serie" />
                </b-col>
                <b-col cols="4" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="me.medidor.certificado" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::           DEFINIÇÕES DA MEDIÇÃO           :::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="mt-2">
            <b-col cols="12" class="p-0">
              <div class="separador-div">
                <strong>DEFINIÇÕES DO ENSAIO</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="2" class="text-left p-0">
              <p class="m-0 p-0">Bloco / Block</p>
            </b-col>
            <b-col cols="2" class="text-left pl-2">
              <p class="m-0 p-0">Certicado / Certif.</p>
            </b-col>
            <b-col cols="2" class="text-left pl-2">
              <p class="m-0 p-0">Velocidade / Speed</p>
            </b-col>
            <b-col cols="2" class="text-left pl-2">
              <p class="m-0 p-0">Acoplante / Couppl.</p>
            </b-col>
            <b-col cols="4" class="text-left pl-2">
              <p class="m-0 p-0">Procedimento / Procedure</p>
            </b-col>

            <b-col cols="2" class="p-0">
              <b-form-input size="sm" v-model="me.bloco.serie" />
            </b-col>
            <b-col cols="2" class="p-0 pl-2">
              <b-form-input size="sm" v-model="me.bloco.certificado" />
            </b-col>
            <b-col cols="2" class="p-0 pl-2">
              <b-form-input size="sm" v-model="me.velocidade" />
            </b-col>
            <b-col cols="2" class="p-0 pl-2">
              <b-form-input size="sm" v-model="me.acoplante" />
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="me.procedimento" />
            </b-col>
          </b-row>

          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::      TIPO DA MEDIÇÃO SELECIONADA = VASO     ::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <div v-if="modelo === 'vaso'">
            <medicao-vaso ref="medicaoVasoReport" />
            <!-- :::::::::::::::::::::::::::::: IMAGEM :::::::::::::::::::::::::::::::: -->
            <b-row class="mt-2">
              <b-img :src="imagem == null ? require('/static/images/me-blank.jpg') : imagem" class="max-size-img" center fluid />
            </b-row>
          </div>

          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::      TIPO DA MEDIÇÃO SELECIONADA = SILO     ::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <div v-if="modelo === 'silo'">
            <b-row class="mt-2">
              <b-col cols="6" class="m-0 p-0 pr-1">
                <medicao-silo ref="medicaoSiloReport" />
              </b-col>

              <b-col cols="6" class="m-0 p-0 pl-1">
                <!-- :::::::::::::::::::::::::::::: IMAGEM :::::::::::::::::::::::::::::::: -->
                <b-row class="mt-2">
                  <b-img
                    :src="imagem == null ? require('/static/images/me-blank.jpg') : imagem"
                    class="max-size-silo"
                    center
                    fluid
                  />
                </b-row>
              </b-col>
            </b-row>
          </div>

          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::      TIPO DA MEDIÇÃO SELECIONADA = VASO     ::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <div v-if="modelo === 'linha'">
            <medicao-linha ref="medicaoLinhaReport" />
          </div>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::: PARTE DETALHES DO RELATORIO :::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row>
            <b-col cols="12" class="p-0 mt-2">
              <div class="separador-div">
                <strong>OBSERVAÇÕES GERAIS</strong>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="p-0">
              <b-form-textarea v-model="me.observacao" :rows="linhas" />
            </b-col>
          </b-row>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::: PARTE INFERIOR DO RELATORIO :::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="4" class="mt-2 p-0 pl-3 pr-3">
              <div class="separador-div">
                <strong>INSPETOR</strong>
              </div>
            </b-col>
            <b-col cols="4" class="mt-2 p-0"> </b-col>
            <b-col cols="4" class="mt-2 p-0 pl-3 pr-3">
              <div class="separador-div">
                <strong>CLIENTE</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="text-left ml-2 mr-2 mb-2">
            <b-col cols="4">
              <inspetor-stamp :profissional="me.inspetor" :preview="stampInspetor" :posicao="'6rem'" key="insp-stamp-pm" />
            </b-col>
            <b-col cols="4" class="m-0 p-0"> </b-col>
            <b-col cols="4">
              <div class="borda-cliente">
                <b-img
                  :src="logoCliente == null ? require('/static/images/sgcq_default.png') : logoCliente"
                  class="rounded-0"
                  fluid
                />
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <me-modal ref="tMedicaoEspessura" />
    <imagem-list-modal ref="imgListME" @loadImagem="loadImagem($event)" />
    <medicoes-modal ref="medicoesME" @loadMedicoes="loadMedicoes($event)" />
    <!-- ::::::::::::::: COMANDOS DO RELATÓRIO ::::::::::::::: -->
    <div class="menu-acoes p-2">
      <div id="search-bar">
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <h4 class="exo-1 m-0 mr-2">SGCQ</h4>
            <b-form-input id="sgcq-call" type="number" size="sm" class="m-1 p-1" placeholder="Sgcq" v-model="sgcq" />
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="primary" @click="loadEquipamento()">
              <b-icon icon="box-arrow-in-up-right" variant="light" scale="1.1" class="mr-2" />Buscar
            </b-button>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="info" @click="loadDetalhes()">
              <b-icon icon="file-earmark-richtext" variant="light" scale="1.1" class="mr-2" />Detalhes
            </b-button>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="info" @click="callImagem()">
              <b-icon icon="image" variant="light" scale="1.1" class="mr-2" />Imagem
            </b-button>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="info" @click="callMedicoes()">
              <b-icon icon="file-break" variant="light" scale="1.1" class="mr-2" />Medições
            </b-button>
            <b-button size="sm" class="ml-2 pl-2 pr-3" variant="warning" v-print="printLaudo">
              <b-icon icon="printer" variant="light" scale="1.1" class="mr-2" />Imprimir
            </b-button>

            <b-form-radio-group
              id="radio-group-1"
              v-model="modelo"
              name="radio-sub-component"
              buttons
              button-variant="outline-light"
              size="sm"
              class="conf-bar"
            >
              <b-form-radio value="vaso">Vasos</b-form-radio>
              <b-form-radio value="silo">Silos</b-form-radio>
              <b-form-radio value="linha">Linhas</b-form-radio>
            </b-form-radio-group>
            <b-form-input id="size-lines" type="number" size="sm" class="m-1 p-1" v-model="linhas" />
          </b-form>
        </b-col>
      </div>
    </div>
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import Files from "@/http/files";
import MedicaoEspessura from "@/models_reports/MedicaoEspessura";
import Cliente from "@/models/Cliente";
import Equipamento from "@/models/Equipamento";
import StampCertificado from "@/components/supports/StampCertificado";
import ImagemListModal from "@/components/modals/imagem/ImagemListModal";
import MedicaoEspessuraModal from "@/components/modals/relatorio/MedicaoEspessuraModal";
import MedicoesModal from "@/components/modals/relatorio/MedicoesModal";
import MedicaoVaso from "@/components/supports/MedicaoVaso";
import MedicaoSilo from "@/components/supports/MedicaoSilo";
import MedicaoLinha from "@/components/supports/MedicaoLinha";

export default {
  name: "MedicaoEspessuraReport",

  components: {
    "inspetor-stamp": StampCertificado,
    "me-modal": MedicaoEspessuraModal,
    "imagem-list-modal": ImagemListModal,
    "medicoes-modal": MedicoesModal,
    "medicao-vaso": MedicaoVaso,
    "medicao-silo": MedicaoSilo,
    "medicao-linha": MedicaoLinha,
  },

  data() {
    return {
      sgcq: 0,
      ativo: false,
      files: new Files(this.$http),
      linhas: 6,
      me: new MedicaoEspessura(),
      cliente: new Cliente(0, "Novo Cliente", "", "", "", "", "", "", ""),
      equipamento: new Equipamento(0, "Novo Equipamento", "", "", "", "", "", "", "", "", ""),
      identificacao: "",
      modelo: "vaso",
      imagem: null,
      stampInspetor: null,
      logoCliente: null,
      printLaudo: {
        id: "MedicaoEspessura",
        popTitle: "SGCQ - Sistema de Gestão e Controle da Qualidade",
      },
    };
  },

  methods: {
    loadEquipamento() {
      if (this.sgcq != 0 && this.sgcq != "") {
        this.equipamento.update(this.getBySgcq(this.sgcq)[0]);
        this.cliente.update(this.equipamento.cliente);
        this.equipamentoStore.LISTAR_SERVICOS(this.equipamento.sgcq).then(() => {
          let servicoData = new Date(this.getLastServico[0].data);
          this.me.data = new Date(this.getLastServico[0].data);
          let ano = servicoData.getFullYear();
          this.me.numero = "RN" + this.getLastServico[0].id + "-" + this.sgcq + "-" + ano + "-ME";
          this.identificacao = this.equipamento.sgcq;
          if (this.equipamento.codigo != "" && this.equipamento.codigo != "- - -") {
            this.identificacao = this.equipamento.sgcq + " - " + this.equipamento.codigo;
          }

          //carrega a logomarca do cliente
          this.files.downloadLogo(this.cliente.id).then((response) => {
            const reader = new FileReader();
            const blob = new Blob([response]);
            reader.readAsDataURL(blob);
            reader.onload = (e) => {
              this.logoCliente = e.target.result;
            };
          });
        });
      }
    },

    loadDetalhes() {
      this.$refs.tMedicaoEspessura.call(this.me);
    },

    callImagem() {
      this.$refs.imgListME.call();
    },

    loadMedicoes(medicoes) {
      switch (this.modelo) {
        case "vaso":
          this.$refs.medicaoVasoReport.update(medicoes);
          break;
        case "silo":
          this.$refs.medicaoSiloReport.update(medicoes);
          break;
        case "linha":
          this.$refs.medicaoLinhaReport.update(medicoes);
          break;
        default:
      }
    },

    loadImagem(imagem) {
      this.imagem = imagem;
    },

    callMedicoes() {
      this.$refs.medicoesME.call(this.me);
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipamentoStore = useEquipamentoStore();
    const { getBySgcq } = storeToRefs(equipamentoStore);
    const { getLastServico } = storeToRefs(equipamentoStore);

    return {
      store,
      equipamentoStore,
      getBySgcq,
      getLastServico,
    };
  },
};
</script>

<style lang="scss" scoped>
#screen-form {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 82vh;
}

.exo-1 {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: italic;
  font-size: 1.4rem;
  padding: 0;
  color: white;
}

.exo-2 {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: italic;
  font-size: 1.8rem;
  text-align: center;
}

.separador-div {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  background-color: #ffbf00;
  border-radius: 4px;
  color: white;
  text-align: justify; /* For Edge */
  text-align-last: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.borda-cliente {
  border: 1px solid lightgray;
  border-radius: 3px;
  padding-top: 1rem;
  padding-left: 3rem;
  min-height: 8.8rem;
}

.menu-acoes {
  background-color: #112a4a;
}

.legend {
  border: 1px solid lightgray;
  font-size: 0.8rem;
}

#sgcq-call {
  width: 6rem;
}

#size-lines {
  width: 4rem;
}

.conf-bar {
  margin-left: 15rem;
}

.adjust-a {
  margin: 0;
  margin-left: 0.2rem;
  margin-right: 0.2rem;
}

.adjust-b {
  margin: 0;
  padding: 0.1rem;
}

.max-size-silo {
  max-width: 34rem;
  max-height: 43rem;
}
</style>
